// extracted by mini-css-extract-plugin
module.exports = {"featureWrapper":"FareFeature-module__featureWrapper___INEPa","infoIcon":"FareFeature-module__infoIcon___n0jns","featureContent":"FareFeature-module__featureContent___lT6G0"};